import env from "$lib/env";
import { get } from "svelte/store";
import settings from "$lib/state/settings";

export const currentApiURL = () => {
    const processingSettings = get(settings).processing;
    const customInstanceURL = processingSettings.customInstanceURL;

    if (processingSettings.enableCustomInstances && customInstanceURL.length > 0) {
        return new URL(customInstanceURL).origin;
    }

    const apiURL = env.DEFAULT_API || '/api';
    // If it's a relative path, construct full URL with origin
    if (apiURL.startsWith('/')) {
        return window.location.origin + apiURL;
    }
    return new URL(apiURL).origin;
}
